import { useMemo } from 'react'
import { useLang } from '@/i18n/useLang'
import { renderPracticeBook } from './practice-book-art'

/** A decorative book, independent of the modeler and present in prerendered HTML. */
export function PracticeBook({ state, framed = false }: { state: number; framed?: boolean }) {
  const { lang } = useLang()
  const drawing = useMemo(() => renderPracticeBook(state, lang), [state, lang])
  return (
    <svg
      className={`practice-book${state === 7 ? ' is-community' : ''}`}
      viewBox={framed ? '-30 -30 1100 1060' : '0 0 1000 960'}
      aria-hidden="true"
      focusable="false"
      data-state={state}
    >
      {/* The renderer accepts only a state and locale. All text is escaped;
          no profile, user input or network content enters this SVG markup. */}
      <g key={`${lang}-${state}`} className="practice-book-frame" dangerouslySetInnerHTML={{ __html: drawing }} />
    </svg>
  )
}
